import { useMantineTheme } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";

const createQuery = (breakpoint: string) => {
  return `(min-width: ${breakpoint})`;
};

export const useIsDesktop = () => {
  const theme = useMantineTheme();
  const isDesktop = useMediaQuery(createQuery(theme.breakpoints.lg));

  return isDesktop;
};
